// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Login_wrapper__GdEDG","login":"Login_login__32gJv","button":"Login_button__x6boO","logoWrapper":"Login_logoWrapper__32FED","appName":"Login_appName__1yIZQ"};